/**
 * Command runner registry — pluggable action handlers for the canonical
 * command system (docs/architecture/command-parity-plan.md).
 *
 * Core, always-present handlers live in commandActions.ts
 * (COMMAND_ACTION_HANDLERS). Feature-runner waves (Z/V/A/B/C/E/L/H/D/G/I/F/
 * J/K) register additional handlers here from their own modules, imported
 * once via runners/index.ts from the CommandRegistrar. This keeps the core
 * module free of the whole engine surface while preserving the single
 * dispatch path: id -> handler -> result message.
 */

export type RunnerHandler = (args?: string[]) => string | void;
export type RunnerMap = Record<string, RunnerHandler>;

const registry: RunnerMap = {};

/** Register a batch of handlers (called once at boot by the runners barrel). */
export function registerCommandActions(map: RunnerMap): void {
    Object.assign(registry, map);
}

export function getRegisteredAction(id: string): RunnerHandler | undefined {
    return registry[id];
}

/** Registered ids (for parity audit tooling). */
export function registeredActionIds(): string[] {
    return Object.keys(registry);
}
